/**
 * @module:  静态类型数据存储
 * @author: Liang Huang
 * @date: 2019-12-17 14:27:29
 */

import { IValue } from './mapping';
// import { when } from "mobx"
// import company from "@src/store/company"
// import { isEmpty } from "./object"

/**
 * 任务筛选我下属的
 */
export const TASK_HAS_UNDER = 5;

/**
 * 任务状态已完成
 */
export const TASK_STATUS_FINISHED = 1;

export const PRIORITY_DATA = [
  { label: '不重要不紧急', value: 1 },
  { label: '紧急但不重要', value: 2 },
  { label: '重要但不紧急', value: 3 },
  { label: '重要且紧急', value: 4 }
];
export const FEATURE_DATA: IValue[] = [
  { name: '原始需求', value: 1 },
  { name: '新增需求', value: 2 },
  { name: '细化衍生需求', value: 3 },
  { name: '变更需求', value: 4 }
];

export const DEFECT_DATA: IValue[] = [
  { name: '功能', value: 1 },
  { name: '性能', value: 2 },
  { name: '接口', value: 3 },
  { name: '安全', value: 4 },
  { name: '兼容', value: 5 },
  { name: 'UI界面', value: 6 },
  { name: '数据问题', value: 7 },
  { name: '逻辑问题', value: 8 },
  { name: '需求问题', value: 9 },
  { name: '不确定', value: 10 }
];
// 严重程度
export const DEEP_DATA: IValue[] = [
  { name: '致命', value: 1 },
  { name: '严重', value: 2 },
  { name: '一般', value: 3 },
  { name: '提示', value: 4 },
  { name: '建议', value: 5 }
];

export const PROBABILITY_DATA: IValue[] = [
  { name: '必现', value: 1 },
  { name: '大概率复现', value: 2 },
  { name: '偶尔复现', value: 3 },
  { name: '仅一次', value: 4 }
];

export const RISK_DATA: IValue[] = [
  { value: 1, name: '已知未发生' },
  { value: 2, name: '已知已发生' },
  { value: 3, name: '未知已发生' }
];

export enum DROP_STATUS {
  filter = 'filter',
  view = 'view',
  exam = 'exam',
  other = 'other',
  offer = 'offer',
  entry = 'entry'
}

export enum INTERVIEW_PASSED {
  pass = 1,
  wait = 2,
  out = 0
}

export enum SEX {
  male = 1,
  female = 2
}
export enum DTYPE {
  person = 1, // 个人投递
  company = 2, // 公司投递
  personSuggest = 3, // 个人推荐
  companySuggest = 4 // 公司推荐
}

export enum GET_CONTACT_SHOW {
  show = '1',
  notShow = '2',
  sended = '3'
}

export enum OKR_CREATE_TYPE {
  company = 1,
  department = 2,
  person = 3
}

export enum OKR_STATUS_TYPE {
  all = '',
  process = 'process',
  finish = 'finish'
}

export enum OKR_TYPE {
  all = '',
  company = 'company',
  department = 'department',
  person = 'person'
}

export enum OKR_TARGET_TYPE {
  all = '',
  manage = 'manage',
  follow = 'follow',
  create = 'create',
  audit = 'audit'
}

export enum OKR_PERIOD {
  year = 'year',
  season = 'season',
  month = 'month',
  custom = 'custom'
}

// 任务类型 (1, '任务'),(2, '需求'),3, 'BUG'),(4, '风险')
export enum TASK_CATEGORY {
  TASK = 1,
  REQUIRE = 2,
  BUG = 3,
  RISK = 4
}

export const TASK_CATOGORY_MAP = {
  [TASK_CATEGORY.TASK]: '任务',
  [TASK_CATEGORY.REQUIRE]: '需求',
  [TASK_CATEGORY.BUG]: '缺陷',
  [TASK_CATEGORY.RISK]: '风险'
};

export enum CHECK_STATUS {
  PROCESS = 1, // 审核中
  WITHDRAW = 2, // 已撤回
  REJECT = 3, // 审核失败
  PASS = 4, // 审核成功
  ACCEPT_PROCESS = 5, // 验收中
  ACCEPT_REJECT = 6, // 验收失败
  ACCEPT_PASS = 7 // 验收成功
}

export enum KR_STATUS {
  PROCESS = 1, // 进行中
  COMPLETE = 2, // 已完成
  NOT_ACTIVE = 3 // 未生效
}

// 单位 1-元, 2-个, 3-笔, 4-%, 5-万元, 6-天, 7-名,8-分,9-台,10-件,11-家,12-次
export enum TARGET_UNIT {
  YUAN = 1,
  QUANTITY = 2,
  BI = 3,
  BAIFEN = 4,
  WANYUAN = 5,
  TIAN = 6,
  MING = 7,
  FEN = 8,
  TAI = 9,
  JIAN = 10,
  JIA = 11,
  CI = 12
}

// 单位map
export const TARGET_UNIT_MAP = {
  [TARGET_UNIT.YUAN]: '元',
  [TARGET_UNIT.QUANTITY]: '个',
  [TARGET_UNIT.BI]: '笔',
  [TARGET_UNIT.BAIFEN]: '%',
  [TARGET_UNIT.WANYUAN]: '万元',
  [TARGET_UNIT.TIAN]: '天',
  [TARGET_UNIT.MING]: '名',
  [TARGET_UNIT.FEN]: '分',
  [TARGET_UNIT.TAI]: '台',
  [TARGET_UNIT.JIAN]: '件',
  [TARGET_UNIT.JIA]: '家',
  [TARGET_UNIT.CI]: '次'
};

/**
 *  成果动作 1-创建审核 2-验收审核 3-修改审核 4-删除审核 5-重新提交审核 6-重新提交验收  7-重新提交修改审核 8-重新提交删除审核
 */
export enum KR_ACTION {
  CREATE_CHECK = 1,
  ACCEPT_CHECK = 2,
  EDIT_CHECK = 3,
  DELETE_CHECK = 4,
  RESUBMIT_CHECK = 5,
  RESUBMIT_ACCEPT = 6,
  REEDIT_CHECK = 7,
  REDELETE_CHECK = 8
}

export const KR_ACTION_MAP = {
  1: '创建提交',
  2: '验收提交',
  3: '修改提交',
  4: '删除提交',
  5: '重新提交审核',
  6: '重新提交验收',
  7: '重新提交修改审核',
  8: '重新提交删除审核',
  9: '创建审核已撤回',
  10: '验收审核已撤回',
  11: '修改审核已撤回',
  12: '删除审核已撤回',
  100: '更新进度'
};

// KR status map
export const KR_STATUS_MAP = {
  1: '创建审核通过',
  2: '验收审核通过',
  3: '修改审核通过',
  4: '删除审核通过',
  5: '重新提交创建审核通过',
  6: '重新提交验收审核通过',
  7: '重新提交修改审核通过',
  8: '重新提交删除审核通过',

  9: '创建审核中',
  10: '验收审核中',
  11: '修改审核中',
  12: '删除审核中',
  13: '重新提交创建审核中',
  14: '重新提交验收中',
  15: '重新提交修改审核中',
  16: '重新提交删除审核中',

  17: '创建审核失败',
  18: '验收审核失败',
  19: '修改审核失败',
  20: '删除审核失败',
  21: '重新提交创建审核失败',
  22: '重新提交验收失败',
  23: '重新提交修改审核失败',
  24: '重新提交删除审核失败'
};

export const RISK_MAP = {
  1: '正常推进',
  2: '存在风险',
  3: '风险失控'
};

export const TASK_PROCESS_CHECK_MAP = {
  2: '初次提交',
  8: '通过',
  7: '退回',
  6: '重新提交',
  9: '撤回'
};

export enum TASK_STATUS {
  PROCESS = 0, // 进行中
  COMPLETE = 1, // 已完成（验收成功）
  ACCEPT_PROCESS = 2, // 验收中
  FAIL = 3 // 验收失败
}

export const PRIORITY_MAP = {
  1: '不重要不紧急',
  2: '紧急但不重要',
  3: '重要但不紧急',
  4: '重要且紧急'
};

export const POINT_MAX = 999999999999;

export enum PAY_METHOD {
  company = 4,
  weixin = 1,
  alipay = 2
}
// 1充值，2提现，3黄豆猎聘，4绩效存储空间
export enum ORDER_TYPE {
  recharge = 1,
  withdraw = 2,
  employ = 3,
  save = 4
}
// 预付费订单状态
export enum ORDER_STATUS {
  waiting = 0, // 0待支付
  cancel = 1, // 1已取消，
  success = 2, // 2支付成功，
  part_account = 3, // 3部分结算，
  accounted = 4, // 4已结算，
  part_rebacking = 5, // 5部分退款中
  part_reback = 6, // 6部分退款
  rebacking = 7, // 7退款中
  rebacked = 8, // 8已退款
  working = 9 // 9处理中
}
/** 职位筛选过滤条件 */
export enum PositionFilterOption {
  /** 类型 */
  OfferProp = 'offer_prop',
  /** 薪资范围 */
  ExpectedSalary = 'expectedSalary',
  /** 工作年限 */
  WorkingYears = 'exper',
  /** 学历要求 */
  EducationRequirements = 'degree',
  /** 发布日期 */
  ReleaseDate = 'relate_date',
  /** 驻场周期 */
  ResidentPeriod = 'period',
  /** 是否可续签 */
  Renewal = 'renewal'
}

/** 计算sticky事件 */
export const CALC_STICKY_EVENT = 'CalculateStickyEvent';

/** 计算sticky事件 */
export const REFRESH_COMMENT_EVENT = 'RefreshCommentEvent';

// 职位审核状态
export enum JobAuditStatus {
  ing = 20, // 进行中
  checking = 10, // 审核中
  over = 30, // 结束
  nopay = 5 // 未支付
}
// 职位审核下线状态
export enum JobAuditOverStatus {
  noPass = 30, // '审核不通过',
  cancel = 40, // '已撤销',
  offline = 50, // '强制下线',  # 这是手动强制结束
  fulled = 60, //, '已招满'
  autoOffLine = 70 //'自动下线'  # 这是报名时间到了的自动下线
}
// 职位类型
export enum OfferProp {
  cloud = 1, // 云工作
  direct = 2, // 直聘
  stand = 3 // 驻场
}
// 付费方式 0 普通职位不付费 1 预付费 2后付费
export enum DeliveryOfferPType {
  normal = 0,
  payed = 1,
  after = 2
}
// 自定义事件集合
export enum EventType {
  cAuthModalClosed = 'cAuthModalClosed'
}

// when(() => {
//   return !isEmpty(company.user.baseData);
// }, () => {
//   console.log('constant init');
//   PRIORITY_DATA = company.user.baseData.task_priority.map(item => ({label: item.name, value: item.id}));
//   FEATURE_DATA = company.user.baseData.task_require_type.map(item => ({label: item.name, value: item.id}));
//   DEFECT_DATA = company.user.baseData.task_bug_type.map(item => ({label: item.name, value: item.id}));
//   DEEP_DATA = company.user.baseData.task_bug_level.map(item => ({label: item.name, value: item.id}));
//   PROBABILITY_DATA = company.user.baseData.task_bug_repeat.map(item => ({label: item.name, value: item.id}));
//   RISK_DATA = company.user.baseData.task_risk_type.map(item => ({label: item.name, value: item.id}));
// })
